import { render, staticRenderFns } from "./m-office-card.vue?vue&type=template&id=2327c1dc"
import script from "./m-office-card.vue?vue&type=script&lang=js"
export * from "./m-office-card.vue?vue&type=script&lang=js"
import style0 from "./m-office-card.vue?vue&type=style&index=0&id=2327c1dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports